const TOOLTIP_BOX_VARIANT = {
  SHORT: 'short',
  LONG: 'long'
};
const TOOLTIP_CAPSULE_VARIANT = {
  STROKE: 'stroke',
  FILL: 'fill'
};
const TOOLTIP_ARROW_DIRECTION_MAP = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
const ANIMATION_STATUS = {
  ENTER: 'enter',
  LEAVE: 'leave'
};

export { ANIMATION_STATUS, TOOLTIP_ARROW_DIRECTION_MAP, TOOLTIP_BOX_VARIANT, TOOLTIP_CAPSULE_VARIANT };
